export default {
      id: "edit-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#edit",
      toString: function () {
        return this.url;
      }
    }